import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { CoralogixRUMService } from './app/services/coralogix-rum.service';

CoralogixRUMService.init(); // Initialize before bootstraping the app to catch errors at all levels

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
